import React, { useState, useCallback } from 'react';
import { motion } from 'framer-motion';
import { Package, Search } from 'lucide-react';
import { useProducts } from '../../context/ProductContext';
import { ProductList } from './ProductList';
import { ProductDetail } from './ProductDetail';
import { FilterContainer } from './filters/FilterContainer';
import { useDebounce } from '../../hooks/useDebounce';

export const ProductsContainer: React.FC = () => {
  const { setSearchTerm, loading, error } = useProducts();
  const [selectedProduct, setSelectedProduct] = useState<string | null>(null);
  const [searchValue, setSearchValue] = useState('');

  const debouncedSetSearchTerm = useDebounce((value: string) => {
    setSearchTerm(value);
  }, 300);

  const handleSearchChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchValue(value);
    debouncedSetSearchTerm(value);
  }, [debouncedSetSearchTerm]);

  return (
    <div className="space-y-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white rounded-lg shadow-lg p-6"
      >
        <div className="flex items-center gap-3 mb-6">
          <Package className="text-orange-500" size={24} />
          <div>
            <h2 className="text-xl font-bold">Productos Mercadona</h2>
            <p className="text-sm text-gray-600">Explora y filtra productos</p>
          </div>
        </div>

        <div className="relative mb-6">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-orange-500" size={20} />
          <input
            type="text"
            placeholder="Buscar productos (mínimo 3 caracteres)..."
            value={searchValue}
            onChange={handleSearchChange}
            className="w-full pl-10 pr-4 py-3 bg-gray-50 border-2 border-orange-100 rounded-lg focus:border-orange-500 focus:ring-2 focus:ring-orange-200 transition-all"
          />
        </div>

        <FilterContainer />

        {error ? (
          <div className="bg-red-50 text-red-600 p-4 rounded-lg mb-6">
            {error}
          </div>
        ) : loading ? (
          <div className="text-center py-12">
            <Package className="mx-auto text-orange-300 animate-spin mb-4" size={48} />
            <p className="text-gray-600">Cargando productos...</p>
          </div>
        ) : (
          <ProductList onProductClick={setSelectedProduct} />
        )}
      </motion.div>

      {selectedProduct && (
        <ProductDetail
          productId={selectedProduct}
          onClose={() => setSelectedProduct(null)}
        />
      )}
    </div>
  );
};